<template>
  <div id="privacy" class="body-container">
    <div class="body-content">
      <terms></terms>


      <privacyCZUR></privacyCZUR>
    </div>
  </div>
</template>

<script>
import terms from '../terms/terms.vue'
import privacyCZUR from '../privacy_CZUR/privacy_CZUR.vue'
export default {
  name: 'privacy',
  data () {
    return {}
  },
  components: {
    privacyCZUR,
    terms
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#privacy
  margin .25rem
  font-size 0.14rem
  line-height 0.24rem
  text-align justify
  height auto
  h1
    font-weight bold
    font-size 0.16rem
  div
    text-indent 0.31rem
    margin .1rem 0
    &.title
      text-indent 0
      font-weight bold
      font-size 0.16rem
    &.sub-p
      text-indent 0.59rem
    a
      color #000
      &:hover
        color #0982cb
</style>



// WEBPACK FOOTER //
// privacy_part.vue?69c0af40